import { creditLimitEventProperties } from './post_approval_plaid_uplift';

const read = (value, key) => value?.get?.(key) ?? value?.[key];

const readPath = (value, path) =>
  path.reduce((current, key) => read(current, key), value);

const safeTransientString = (value) =>
  typeof value === 'string' && value.length <= 64 && value ? value : null;

export const isNoChangeResult = (attempt) =>
  read(attempt, 'status') === 'no_change';

export const retainedCreditLimit = ({ attempt, company } = {}) => {
  const baselineCents = readPath(attempt, ['baseline', 'approved_credit_limit', 'cents']);
  const minimum = isNoChangeResult(attempt)
    ? Number.isSafeInteger(baselineCents) && baselineCents >= 0
      ? baselineCents / 100
      : null
    : 0;
  if (minimum === null) return null;

  const cents = readPath(attempt, ['effective', 'approved_credit_limit', 'cents']);
  if (Number.isSafeInteger(cents) && cents >= 0 && cents / 100 >= minimum) {
    return cents / 100;
  }

  const amount = readPath(company, ['credit_line', 'amount']);
  return Number.isFinite(amount) && amount >= minimum ? amount : null;
};

export const linkedAccountSummary = ({ attempt, linkedAccount } = {}) => {
  if (read(attempt, 'account_ready') !== true) {
    return null;
  }

  return {
    mask: read(attempt, 'account_mask'),
    institution: safeTransientString(linkedAccount?.institution),
    name: safeTransientString(linkedAccount?.name),
  };
};

export const continuationTarget = ({ attempt } = {}) =>
  isNoChangeResult(attempt) &&
  read(attempt, 'can_continue') === true &&
  read(attempt, 'next_route_path')
    ? { kind: 'path', path: read(attempt, 'next_route_path') }
    : isNoChangeResult(attempt) && read(attempt, 'can_continue') === true
      ? { kind: 'route' }
      : null;

export const resultViewEventProperties = ({ session, attempt } = {}) => ({
  sessionType: read(session, 'session_type') ?? null,
  hasShoppingCart:
    typeof session?.hasShoppingCart === 'function'
      ? session.hasShoppingCart()
      : !!read(session, 'shopping_cart_id'),
  attemptStatus: 'no_change',
  accountReady: read(attempt, 'account_ready') === true,
  underwritingEnhanced: read(attempt, 'company_underwriting_enhanced') === true,
  ...creditLimitEventProperties(attempt),
});
